import React, { useState, useEffect } from "react";
import { Row, Col, Button, Spin, message } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { setAllShiftCategoryList } from "redux/actions";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { getEditShiftJson } from "JsonFormat/EditShiftJson";
import styled from "styled-components";
import { LoadingOutlined } from "@ant-design/icons";

const formatMinutesAsHHMM = (totalSeconds) => {
  const seconds = parseInt(totalSeconds, 10);
  if (isNaN(seconds) || seconds < 0) {
    return "";
  }
  return `${Math.floor(seconds / 60)} mins`;
};

const formatMinutesAsHHMMSS = (totalSeconds) => {
  const seconds = parseInt(totalSeconds, 10);
  if (isNaN(seconds) || seconds < 0) {
    return "00:00:00";
  }
  const mm = String(Math.floor(seconds / 60)).padStart(2, "0");
  const ss = String(seconds % 60).padStart(2, "0");
  return `00:${mm}:${ss}`;
};

const parseBufferTimeToSeconds = (value) => {
  if (typeof value === "string" && value.includes(":")) {
    const parts = value.split(":").map(Number);
    if (parts.some((part) => isNaN(part))) {
      return value;
    }
    const [hh = 0, mm = 0, ss = 0] = parts;
    return hh * 3600 + mm * 60 + ss;
  }
  return value;
};

const EditShift = ({
  isModalVisible,
  closeModal,
  getShiftList,
  ShiftDetails,
  viewOnly,
  saveAllShiftCategory,
}) => {
  const [data, setData] = useState({});
  const [create, setCreate] = useState(false);

  useEffect(() => {
    setData({
      shiftCategoryId: ShiftDetails.shiftCategoryId,
      startTime: ShiftDetails.startTime,
      endTime: ShiftDetails.endTime,
      weekendWorking: ShiftDetails.weekendWorking,
      checkinBufferTime: parseBufferTimeToSeconds(
        ShiftDetails.checkinBufferTime
      ),
      checkoutBufferTime: parseBufferTimeToSeconds(
        ShiftDetails.checkoutBufferTime
      ),
    });
  }, [ShiftDetails]);

  const { EditShiftForm } = getEditShiftJson(data);

  const handleFormChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const onFinish = async () => {
    setCreate(true);
    const {
      shiftCategoryId,
      startTime,
      endTime,
      weekendWorking,
      checkinBufferTime,
      checkoutBufferTime,
    } = data;

    const { code } = await CALL_API(
      `settings/shift/shift-category/${shiftCategoryId}`,
      "patch",
      {
        starttime: startTime,
        endtime: endTime,
        weekendworking: weekendWorking,
        checkinbuffertime: formatMinutesAsHHMMSS(checkinBufferTime),
        checkoutbuffertime: formatMinutesAsHHMMSS(checkoutBufferTime),
      }
    );

    setCreate(false);
    if (code === STATUS_CODE.SUCCESS) {
      message.success("Shift has been updated successfully");
      closeModal(false);
      getShiftList();
    }
  };

  const handleSave = async () => {
    await onFinish();
  };

  return (
    <>
      {isModalVisible && (
        <>
          <ShiftStyle>
            <div className="d-flex justify-content-between">
              <div className="shift_header_content">
                <b className="mb-3" style={{ fontSize: "20px" }}>
                  Shift
                </b>
              </div>
              <div className="shift_header_action">
                {!viewOnly && (
                  <Button type="primary" onClick={handleSave}>
                    {create && <Spin indicator={<LoadingOutlined spin />} />}Update
                  </Button>
                )}
              </div>
            </div>
          </ShiftStyle>

          {viewOnly ? (
            <div className="styled-card" style={{ marginTop: "10px" }}>
              <Row className="mb-1">
                <Col>
                  <b>Start Time</b> : {data.startTime}
                </Col>
              </Row>
              <Row className="mb-1">
                <Col>
                  <b>End Time</b> : {data.endTime}
                </Col>
              </Row>
              <Row className="mb-1">
                <Col>
                  <b>Weekend Working</b> : {data.weekendWorking}
                </Col>
              </Row>
              <Row className="mb-1">
                <Col>
                  <b>Check-In Buffer Time</b> :{" "}
                  {formatMinutesAsHHMM(data.checkinBufferTime)}
                </Col>
              </Row>
              <Row className="mb-1">
                <Col>
                  <b>Check-Out Buffer Time</b> :{" "}
                  {formatMinutesAsHHMM(data.checkoutBufferTime)}
                </Col>
              </Row>
            </div>
          ) : (
            <div className="styled-card" style={{ marginTop: "10px" }}>
              <GridBuilder
                formStructureJson={EditShiftForm}
                handleChange={handleFormChange}
                initialValues={data}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveAllShiftCategory: setAllShiftCategoryList,
    },
    dispatch
  );
export default connect(null, mapDispatchToProps, null)(EditShift);

const ShiftStyle = styled.div`
  .shift_header_content {
    width: max-content;
  }
  .shift_header_action {
    width: max-content;
  }
`;
